import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../providers/AppDataProvider';

const resourceName = 'prediction-trading';
const cursorStore = new Map<string, Map<number, string | undefined>>();

const toQueryParamValue = (key: string, value: unknown) => {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }

  if ((key === 'from' || key === 'to') && (typeof value === 'number' || typeof value === 'string')) {
    const timestamp = Number(value);

    if (!Number.isNaN(timestamp)) {
      return new Date(timestamp).toISOString();
    }
  }

  return String(value);
};

const buildQueryParams = (filter: Record<string, any>, perPage: number, cursor?: string) => {
  const queryParams = new URLSearchParams();

  Object.entries(filter).forEach(([key, value]) => {
    const queryValue = toQueryParamValue(key, value);

    if (queryValue !== undefined) {
      queryParams.set(key, queryValue);
    }
  });

  queryParams.set('limit', String(perPage));

  if (cursor) {
    queryParams.set('cursor', cursor);
  }

  return queryParams;
};

export const resetPredictionTradingCursorStore = () => {
  cursorStore.clear();
};

const getQueryKey = (params: GetListParams) =>
  JSON.stringify({
    filter: params.filter ?? {},
    sort: params.sort ?? null,
    perPage: params.pagination?.perPage ?? 10,
  });

class PredictionTradingDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== resourceName) return Promise.reject(new Error('Unsupported resource'));

    const { page = 1, perPage = 10 } = params.pagination || {};
  const filter = (params.filter ?? {}) as Record<string, any>;
    const queryKey = getQueryKey(params);
    const pageCursors = cursorStore.get(queryKey) ?? new Map<number, string | undefined>([[1, undefined]]);
    cursorStore.set(queryKey, pageCursors);

    const cursor = page === 1 ? undefined : pageCursors.get(page);
  const queryParams = buildQueryParams(filter, perPage, cursor);

    const url = `${baseUrl}/prediction/admin-builder-trade-stats/latest-trades?${queryParams.toString()}`;
    const { json } = await httpClient(url, { method: 'GET' });

    const rows: any[] = json?.data ?? json?.list ?? json?.items ?? json?.records ?? [];
    const nextCursor = json?.pageInfo?.nextCursor;

    if (nextCursor) {
      pageCursors.set(page + 1, nextCursor);
    } else {
      pageCursors.delete(page + 1);
    }

    const data = rows.map((row: any, index: number) => ({
      id: row?.id ?? row?.tradeId ?? row?.transactionHash ?? `${page}-${index}`,
      ...row,
    }));

    return {
      data,
      pageInfo: {
        hasNextPage: Boolean(nextCursor),
        hasPreviousPage: page > 1,
      },
    };
  }
}

export const predictionTradingDataProvider = new PredictionTradingDataProvider();

registerModuleDataProvider(resourceName, predictionTradingDataProvider);
